module.exports = __webpack_public_path__ + "img/afiliacao.24aa1d43.svg";